<ng-container *ngIf="(data$ | async) as data">

  <div class="footer" [ngStyle]="{background: data?.tenant?.customFooterConfig?.footerColor ?? '#474e50'}">

    <div class="footer-container">
      <div class="column-container logo-container">

        <img class="custom-logo" *ngIf="data?.tenant?.customFooterConfig?.footerCustomLogoUrl"
          [src]="data?.tenant?.customFooterConfig?.footerCustomLogoUrl">

        <div class="social-media-link">

          <ng-container *ngFor="let socialMedia of data?.tenant?.customFooterConfig?.socialMedias">

            <a class="social-media-icon" [href]="socialMedia?.link" target="_blank" *ngIf="socialMedia.link">
              <i *ngIf="socialMedia?.title == 'Facebook'">
                <img class="social-media-logo" [src]="facebookUrl" alt="facebook icon">
              </i>
              <i *ngIf="socialMedia?.title == 'Twitter'">
                <img class="social-media-logo" [src]="twitterUrl" alt="twitter icon">
              </i>
              <i *ngIf="socialMedia?.title == 'YouTube'">
                <img class="social-media-logo" [src]="youtubeUrl" alt="youtube icon">
              </i>
              <i *ngIf="socialMedia?.title == 'Instagram'">
                <img class="social-media-logo" [src]="instagramUrl" alt="instagram icon">
              </i>
              <i *ngIf="socialMedia?.title == 'LinkedIn'">
                <img class="social-media-logo" [src]="linkedinUrl" alt="linkedin icon">
              </i>
            </a>

          </ng-container>

        </div>



        <div class="custom-container" *ngFor="let customLink of data?.tenant?.customFooterConfig?.customLinkConfig">

          <div class="custom-heading">{{customLink?.section}}</div>

          <div class="links">
            <a *ngFor="let link of customLink?.links" [href]="link?.link" target="_blank">
              <span>{{link?.title}}</span>
            </a>
          </div>

        </div>

        <div class="custom-container"
          *ngIf="data?.tenant?.termsOfServiceUrl || data?.tenant?.privacyPolicyUrl || data?.tenant?.legalDisclosureUrl">

          <div class="custom-heading">{{ ("footer.legal" | translate) }}</div>

          <div class="links">
            <a *ngIf="data?.tenant?.termsOfServiceUrl" [href]="data?.tenant.termsOfServiceUrl" target="_blank">{{
              ("footer.termsOfService" | translate) }}</a>

            <a *ngIf="data?.tenant?.privacyPolicyUrl" [href]="data?.tenant.privacyPolicyUrl" target="_blank">{{
              ("footer.privacyPolicy" | translate) }}</a>

            <a *ngIf="data?.tenant?.legalDisclosureUrl" [href]="data?.tenant.legalDisclosureUrl" target="_blank">{{
              ("footer.legalDisclosure" | translate) }}</a>

          </div>

        </div>

        <language-dropdown uiMode="dark-mode" [language]="data?.sessionLanguage ?? 'en'"
          *ngIf="isLanguageDropdownVisible(data)" (languageChanged)="onLanguageChanged($event)"></language-dropdown>

      </div>

    </div>
    <div class="footer-bottom-bar"
      [ngClass]="( !data.tenant?.instructorPricingPlan?.includes('enterprise') ) ? 'item-space-between' : 'item-center'">
      <div class="copyright-container" [ngClass]="{'platform-logo-on': isPlatformLogoVisible(data)}">
        <div class="copyright-text" *ngIf="data?.tenant?.customFooterConfig?.websiteCopyRightText">
          {{data?.tenant?.customFooterConfig?.websiteCopyRightText}}
        </div>
        <ng-container *ngIf="!data.tenant?.disablePlatformBranding">

          <div class="powered-by" *ngIf="isPlatformLogoVisible(data)">
            <!-- <div class="label">{{ ("footer.poweredBy" | translate) }}  </div> -->
            <a href="https://onlinecoursehost.com" target="_blank">
              <img class="powered-by-logo" [src]="onlinecourseUrl">
            </a>
          </div>

        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
